module.exports = __webpack_public_path__ + "img/business1.5cdd6e8f.jpg";